/**
 * Blog Service
 * Fetches blog posts from the RSS API endpoint
 */

const API_BASE = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001';

/**
 * Fetch latest blog posts (default: 3)
 */
export async function fetchLatestPosts(count = 3) {
  try {
    const response = await fetch(`${API_BASE}/api/blog/latest?count=${count}`);
    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.message || 'Failed to fetch blog posts');
    }
    
    return data.posts;
  } catch (error) {
    console.error('[BlogService] Error fetching latest posts:', error);
    return [];
  }
}

/**
 * Fetch all blog posts
 */
export async function fetchAllPosts() {
  try {
    const response = await fetch(`${API_BASE}/api/blog/posts`);
    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.message || 'Failed to fetch blog posts');
    }
    
    return {
      posts: data.posts,
      total: data.total,
      cached: data.cached
    };
  } catch (error) {
    console.error('[BlogService] Error fetching all posts:', error);
    return { posts: [], total: 0, cached: false };
  }
}

/**
 * Format date for display
 */
export function formatBlogDate(dateString) {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch {
    return dateString;
  }
}

export default {
  fetchLatestPosts,
  fetchAllPosts,
  formatBlogDate
};
